import { Action, createReducer, on } from '@ngrx/store';
import { addSalesproposalData, addSalesproposalDataFailure, addSalesproposalDataSuccess, cancelSalesproposalRecord, cancelSalesproposalRecordFailure, cancelSalesproposalRecordSuccess, clearSalesproposalData, createHoldRecord, createHoldRecordFailure, createHoldRecordSuccess, createSalesproposalCommentRecord, createSalesproposalCommentRecordSuccess, createRevisionRecord, createRevisionRecordSuccess, editSalesproposalData, editSalesproposalDataFailure, editSalesproposalDataSuccess, fetchSalesproposalAttachments, fetchSalesproposalAttachmentsFailure, fetchSalesproposalAttachmentsSuccess, fetchSalesproposalCancelReasonsList, fetchSalesproposalCancelReasonsListSuccess, fetchSalesproposalMembersList, fetchSalesproposalMembersListSuccess, fetchSalesproposalRecordComments, fetchSalesproposalRecordCommentsFailure, fetchSalesproposalRecordCommentsSuccess, fetchSalesproposalRecordRevisions, fetchSalesproposalRecordRevisionsFailure, fetchSalesproposalRecordRevisionsSuccess, fetchSalesproposalRecordholdunhold, fetchSalesproposalRecordholdunholdFailure, fetchSalesproposalRecordholdunholdSuccess, fetchSalesproposalsListData, fetchSalesproposalsListFailure, fetchSalesproposalsListSuccess, fetchSingleSalesproposalRecordData, fetchSingleSalesproposalRecordDataFailure, fetchSingleSalesproposalRecordDataSuccess, updateSalesproposalStatus, updateSalesproposalStatusFailure, updateSalesproposalStatusSuccess } from "./salesproposal.actions";
import { SalesproposalModel } from '../../core/models/salesproposal.models';
import { TimelineModel } from '../../core/models/timeline.models';
import { CommentModel } from '../../core/models/comments.models';
import { RevisionModel } from '../../core/models/revisions.models';
import { HoldModel } from '../../core/models/hold.model';
import { ProjectTeamModel } from '../../core/models/projectteam.model';

export interface SalesproposalState {
    tabid: number;
    salesproposals: SalesproposalModel[];
    loading: boolean;
    error: any;
    isadded: boolean;
    timelines: TimelineModel[];
    salesproposalrecord: any;
    comments: CommentModel[];
    revisions: RevisionModel[];
    holdunhold: HoldModel[];
    teammembers: ProjectTeamModel[];
    jobcancelreasons: any;
    attachments: any[]
}

export const initialState: SalesproposalState = {
    tabid: 1,
    salesproposals: [],
    loading: true,
    error: null,
    isadded: false,
    timelines: [],
    salesproposalrecord: null,
    comments: [],
    revisions: [],
    holdunhold: [],
    teammembers: [],
    jobcancelreasons: null,
    attachments: []
};

export const SalesproposalReducer = createReducer(
    initialState,

    // Plan Set Vendor
    on(fetchSalesproposalsListData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchSalesproposalsListSuccess, (state, { Salesproposals: salesproposals, tabid: tabid }) => {
        return { ...state, salesproposals, loading: false, tabid: tabid };
    }),
    on(fetchSalesproposalsListFailure, (state, { error, tabid: tabid }) => {
        return { ...state, error, loading: false, tabid: tabid };
    }),

     // Add Plan Set
     on(addSalesproposalData, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(addSalesproposalDataSuccess, (state) => {
        return { ...state, isadded: true, loading: false };
    }),
    on(addSalesproposalDataFailure, (state, { error }) => {
        return { ...state, error, loading: false, isadded: false };
    }),

    // fetch Plan Set
    on(fetchSingleSalesproposalRecordData, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchSingleSalesproposalRecordDataSuccess, (state, { salesproposalrecord: salesproposalrecord }) => {
        return { ...state, isadded: true, loading: false, salesproposalrecord };
    }),
    on(fetchSingleSalesproposalRecordDataFailure, (state, { error }) => {
        return { ...state, error, loading: false, isadded: false };
    }),
    on(clearSalesproposalData, () => {
        return { ...initialState };
    }),

    // Put Plan Set
    on(updateSalesproposalStatus, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(updateSalesproposalStatusSuccess, (state) => {
        return { ...state, loading: false, isadded: true };
    }),
    on(updateSalesproposalStatusFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Get Comments
    on(fetchSalesproposalRecordComments, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchSalesproposalRecordCommentsSuccess, (state, { comments: comments }) => {
        return { ...state, loading: false, comments };
    }),
    on(fetchSalesproposalRecordCommentsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Get Revisions
    on(fetchSalesproposalRecordRevisions, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchSalesproposalRecordRevisionsSuccess, (state, { revisions: revisions }) => {
        return { ...state, loading: false, revisions };
    }),
    on(fetchSalesproposalRecordRevisionsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Get Hold/Unhold Records
    on(fetchSalesproposalRecordholdunhold, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(fetchSalesproposalRecordholdunholdSuccess, (state, { holdunhold: holdunhold }) => {
        return { ...state, loading: false, holdunhold };
    }),
    on(fetchSalesproposalRecordholdunholdFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

     // PUT REQUEST ON HOLD
     on(createHoldRecord, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(createHoldRecordSuccess, (state, { holdrecord }) => {
        return { ...state, loading: false, error: null, holdunhold: holdrecord };
    }),

    // PUT REQUEST REVISION
    on(createRevisionRecord, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(createRevisionRecordSuccess, (state) => {
        return { ...state, loading: false, error: null };
    }),

    // CREATE SALESPROPOSAL COMMENT RECORD
    on(createSalesproposalCommentRecord, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(createSalesproposalCommentRecordSuccess, (state, { comment }) => {
        return { ...state, loading: false, error: null, comments: comment };
    }),

    // CREATE SALESPROPOSAL COMMENT RECORD
    on(fetchSalesproposalMembersList, (state) => {
        return { ...state, loading: true, error: null};
    }),
    on(fetchSalesproposalMembersListSuccess, (state, { memberslist }) => {
        return { ...state, loading: false, error: null, teammembers: memberslist };
    }),

    // FETCH JOB CANCEL REASONS
    on(fetchSalesproposalCancelReasonsList, (state) => {
        return { ...state, error: null};
    }),
    on(fetchSalesproposalCancelReasonsListSuccess, (state, { reasons }) => {
        return { ...state, error: null, jobcancelreasons: reasons };
    }),
    // CANCEL SALESPROPOSAL RECORD
    on(cancelSalesproposalRecord, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(cancelSalesproposalRecordSuccess, (state) => {
        return { ...state, loading: false };
    }),
    on(cancelSalesproposalRecordFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // SALESPROPOSAL ATTACHMENTS
    on(fetchSalesproposalAttachments, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchSalesproposalAttachmentsSuccess, (state, { attachments}) => {
        return { ...state, loading: false, attachments};
    }),
    on(fetchSalesproposalAttachmentsFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

     // Edit Plan Set
     on(editSalesproposalData, (state) => {
        return { ...state, loading: true, error: null, isadded: false };
    }),
    on(editSalesproposalDataSuccess, (state) => {
        return { ...state, isadded: true, loading: false };
    }),
    on(editSalesproposalDataFailure, (state, { error }) => {
        return { ...state, error, loading: false, isadded: false };
    }),
);

// Selector
export function reducer(state: SalesproposalState | undefined, action: Action) {
    return SalesproposalReducer(state, action);
}
